import { render, staticRenderFns } from "./academy-view-toolbar.vue?vue&type=template&id=91a8b7ea&"
import script from "./academy-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./academy-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports